<template>
  <div class="map-box">
    <vl-map ref="map" @moveend="onMoveEnd" :load-tiles-while-animating="true" :load-tiles-while-interacting="true"
            @click="clickCoordinate($event)" data-projection="EPSG:4326" style="height: 900px">
      <vl-view  :zoom.sync="zoom" :center.sync="center" :rotation.sync="rotation"></vl-view>
      <vl-layer-tile>
        <vl-source-xyz :attributions="attribution" :url="url"></vl-source-xyz>
      </vl-layer-tile>
      <vl-layer-vector>
        <vl-source-vector ref="featurelayer">
        </vl-source-vector>
        <vl-style-func :factory="clusterStyleFunc"/>
      </vl-layer-vector>
    </vl-map>
    <div class="map-tile-box">
      <ul>
        <li class="tile-sbox" v-for="item in neardata" v-bind:key="item.identifier">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <div v-on="on" class="thumbnail"><router-link :to="'\/uuid\/' + item.identifier"><img v-bind:src="item.screen" alt="" /></router-link></div>
            </template>
            <span>
              <h4><span v-for="c in item.subject" v-bind:key="c">{{ c }}&nbsp;</span></h4>
              <p>{{ item.description }}</p>
              <p>撮影日時：{{item.created | dateFormatter}}<br>撮影場所：{{item.spatial}}</p>
              <p>投稿者　：<span v-for="c in item.creator"  v-bind:key="c">{{ c }}</span><br>投稿日　：{{item.dateSubmitted| dateFormatter}}</p>
            </span>
          </v-tooltip>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
 import { findPointOnSurface, createStyle, extentToLonLat } from 'vuelayers/lib/ol-ext'
 export default {
     components: {
     },
     data () {
         return { 
             zoom: 8,
             center: [140, 39],
             rotation: 0,
             overlayCoordinate: [140, 39],
             neardata: [],
             url: 'https://cyberjapandata.gsi.go.jp/xyz/seamlessphoto/{z}/{x}/{y}.jpg',
             attribution: "<a href='https://maps.gsi.go.jp/development/ichiran.html' target='_blank'>地理院タイル</a>",
         }
     },
     computed: {
     },
     created(){
         this.features();
         this.$store.subscribe(() => {
             this.features()
             if(this.$refs.map){
                 this.$refs.map.updateSize()
             }
         }
         )

     },

     methods:{
         pointOnSurface(geometry){
             findPointOnSurface(geometry);
         },
         clickCoordinate(event){
             console.log(event.coordinate)
             this.overlayCoordinate = event.coordinate
             this.$emit('nearmode', event.coordinate, this.$refs.map._view.values_.resolution)
             
         },
         onMoveEnd () {
             var extent = extentToLonLat(this.$refs.map._view.calculateExtent());
             this.$emit('mapmode', extent, this.$refs.map._view.values_.resolution)
         },
         features(){
             if(!this.$refs.featurelayer) return;

             this.$refs.featurelayer.clearFeatures();
             if(this.$store.state.mapdata.features){
                 this.$refs.featurelayer.addFeatures(this.$store.state.mapdata.features);
             }
             if(!this.$store.state.neardata.channel || !this.$store.state.neardata.channel.item) {
                 this.neardata = [];
             }else{
                 this.neardata = this.$store.state.neardata.channel.item
             }


         },

         clusterStyleFunc () {
             const cache = {}
             
             return function __clusterStyleFunc (feature) {
                 const size =  feature.values_.count;
                 if(size == 0)  return []
                 let style = cache[size]

                 if (!style) {
                     style = createStyle({
                         imageRadius: Math.log(size) * 2 + 10,
                         strokeColor: '#fff',
                         fillColor: '#3399cc',
                         text: String(size),
                         textFillColor: '#fff',
                     })
                     cache[size] = style
                 }
                 return [style]
             }
         },
     }
 }
 
</script>
<style>

 /*---------------------------------

    map

    ----------------------------------*/

 article {
     position: relative;
 }

 .map-box {
     margin: 20px 250px 0 0;
 }

 .map-tile-box {
     position: absolute;
     right: 0;
     top: 70px;    
     width: 217px;
     height: 900px;
     overflow-y: auto;
     overflow-x: hidden;
 }

 .map-tile-box .tile-sbox { 
     width: 200px;
     float: left;
     margin: 0 20px 20px 0;
 }

 .map-tile-box .thumbnail{
     width: 200px;
     overflow: hidden;
     margin: 0;
     display: block;
 }

 .map-tile-box .thumbnail a {
     display: block;
 }

 .map-tile-box .thumbnail img{
     width: auto;
     height: 200px;
 }

 overlay{
     height:150px;
 }

 .map-tile-box .v-tooltip__content {
     left: 0 !important;
 }



</style>

